import { fetch } from '@atlassian/eoc-fetch';

import type { LogSettingsResponseType } from './types';

export const fetchUiSettingsEndpoint = async (): Promise<LogSettingsResponseType> => {
	return fetch<LogSettingsResponseType>('/v1/logs');
};
